<template>
  <section>
    <div
      class="tw:flex tw:flex-col tw:w-full tw:lg:max-w-(--tw-breakpoint-landing) tw:md:max-w-[638px] tw:sm:max-w-[480px] tw:max-w-[300px] tw:mx-auto"
    >
      <div class="tw:flex tw:md:flex-row tw:flex-col tw:relative">
        <div
          ref="containerRef"
          class="tw:flex tw:flex-col tw:md:flex-row tw:w-vw tw:overflow-hidden carousel-container tw:lg:w-[880px] tw:md:w-[550px] tw:sm:w-[480px] tw:w-[300px] tw:mx-auto"
        >
          <div class="inner reviews_carousel" ref="inner" :style="innerStyles">
            <div
              ref="boxesRef"
              class="line-shadow tw:border tw:border-gray-600 tw:p-4 tw:lg:p-6 tw:lg:min-w-[878px] tw:lg:w-[879px] tw:lg:min-w-[878px] tw:lg:w-[879px] tw:min-w-[299px] tw:min-w-[299px] tw:min-h-[100%] tw:min-h-[100%]"
              :class="
                isLandingPage
                  ? ' tw:md:min-w-[543px] tw:md:w-[543px] tw:sm:min-w-[400px] landing-card'
                  : ' tw:sm:min-w-[543px] tw:sm:w-[543px] card'
              "
              :id="review.id"
              v-for="review in reviews"
              :key="review.id"
            >
              <div class="tw:flex-col tw:md:flex-row tw:gap-y-4 tw:md:gap-x-4 tw:flex">
                <div class="tw:flex tw:lg:min-w-[304px] tw:items-stretch tw:md:min-w-[208px]">
                  <img
                    :src="review.image"
                    :alt="$t('tbs_testimonials')"
                    class=""
                    :class="
                      isLandingPage
                        ? 'tw:h-[221px] tw:object-cover'
                        : 'tw:h-[160px] tw:lg:h-[231px] tw:md:h-auto tw:w-full tw:object-cover tw:rounded-lg'
                    "
                  />
                </div>
                <div class="tw:w-auto tw:flex tw:flex-col tw:h-full tw:justify-between tw:justify-center">
                  <h3 v-if="withHeader" class="tw:font-bold tw:leading-[20px] tw:text-xs">
                    {{ $t('tbs_testimonials') }}
                  </h3>
                  <p class="tw:text-xl tw:leading-[25px] tw:my-4 tw:font-bold">
                    {{ $t(review.text) }}
                  </p>
                  <p class="tw:lg:text-base" v-html="$t(review.author)" />
                  <p class="tw:lg:text-base" v-html="$t(review.location)" />
                  <BaseLink
                    v-if="withReadMore"
                    :href="review.link"
                    @click="sendEvent(review)"
                    target="_blank"
                    class="tw:flex tw:items-center tw:mt-8 tw:cursor-pointer tw:hover:underline tw:text-[revert] tw:text-sm tw:font-bold tw:text-blue-700"
                  >
                    {{ $t('read_more') }}
                    <ChevronRight class="tw:hover:cursor-pointer tw:size-6 tw:fill-blue-700" />
                  </BaseLink>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button class="tw:hidden tw:md:flex tw:absolute tw:left-0 middle" @click="prev">
          <img :src="arrow_left" alt="left" />
        </button>
        <button class="tw:hidden tw:md:flex tw:absolute tw:right-0 middle" @click="next">
          <img :src="arrow_right" alt="right" />
        </button>

        <div class="tw:flex tw:md:hidden tw:mx-auto tw:mt-4 tw:gap-x-6">
          <button @click="prev"><img :src="arrow_left" alt="left" /></button>
          <button @click="next"><img :src="arrow_right" alt="right" /></button>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, nextTick, watch, onBeforeUnmount } from 'vue'

import TouchEvent from '@/utils/touchEvents.ts'
import BaseLink from '@/components/BaseLink.vue'
import ChevronRight from '@/components/icons/ChevronRight.svg?component'

import appAnalytics from '@/utils/tracking'

import { useSessionValues } from '@/composables/useSessionValues'

const containerRef = ref(null)
const boxesRef = ref([])
const { language } = useSessionValues()

defineProps({
  withReadMore: Boolean,
  withHeader: Boolean,
  isLandingPage: Boolean,
})

const review_slider_1 = new URL('/src/assets/img/rate-connect-landing/Testimonial_slider_image7.png', import.meta.url)
  .href
const review_slider_3 = new URL('/src/assets/img/rate-connect-landing/Testimonial_slider_image8.png', import.meta.url)
  .href
const review_slider_2 = new URL('/src/assets/img/rate-connect-landing/Testimonial_slider_image9.png', import.meta.url)
  .href

const arrow_left = new URL('/src/assets/img/rate-connect-landing/icons/arrow_left_icon.svg', import.meta.url)
const arrow_right = new URL('/src/assets/img/rate-connect-landing/icons/arrow_right_icon.svg', import.meta.url)

const reviews = ref([
  {
    image: review_slider_1,
    id: 'review_1',
    text: 'hotelier_highlights_1_quote',
    author: 'hotelier_highlights_1_hotel',
    location: 'hotelier_highlights_1_location',
    link: 'https://www.businessblog-trivago.com/success-stories?pgid=map56075-eeb524_d240c77c65a6485b8c7362b9148969a6mv2.jpg',
  },
  {
    image: review_slider_2,
    id: 'review_2',
    text: 'hotelier_highlights_2_quote',
    author: 'hotelier_highlights_2_hotel',
    location: 'hotelier_highlights_2_location',
    link: 'https://www.businessblog-trivago.com/success-stories?pgid=map56075-eeb524_f9edc6c564ab41b08ece6150a4d67fc5mv2.jpg',
  },
  {
    image: review_slider_3,
    id: 'review_3',
    text: 'hotelier_highlights_3_quote',
    author: 'hotelier_highlights_3_hotel',
    location: 'hotelier_highlights_3_location',
    link: 'https://www.businessblog-trivago.com/success-stories?pgid=map56075-eeb524_401e06e65eef40bf9cac4e93ff35da82mv2.jpg',
  },
])

const touchEvent = ref(null)
const current = ref(1)
const inner = ref(null)
const innerStyles = ref({})
const step = ref('')
const transitioning = ref(false)

const setEqualHeight = async () => {
  if (window.innerWidth < 786) {
    boxesRef.value.forEach(box => (box.style.height = 'auto'))
    return
  }
  const boxes = boxesRef.value
  if (!boxes || boxes.length === 0) return

  boxes.forEach(box => {
    box.style.height = 'auto'
  })

  await nextTick()

  let maxHeight = 0

  boxes.forEach(box => {
    const currentHeight = box.offsetHeight
    if (currentHeight > maxHeight) {
      maxHeight = currentHeight
    }
  })

  boxes.forEach(box => {
    box.style.height = maxHeight + 'px'
  })
}

watch(language, () => {
  nextTick(() => setEqualHeight())
})

onMounted(async () => {
  await nextTick()
  setEqualHeight()
  setStep()
  document.addEventListener('touchstart', event => {
    touchEvent.value = new TouchEvent(event)
  })

  document.addEventListener('touchend', handleSwipe)
  window.addEventListener('resize', setEqualHeight)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', setEqualHeight)
  document.removeEventListener('touchend', handleSwipe)
})

const afterTransition = callback => {
  const listener = () => {
    callback()
    inner.value?.removeEventListener('transitionend', listener)
  }
  inner.value?.addEventListener('transitionend', listener)
}

const resetTranslate = () => {
  innerStyles.value = {
    transition: 'none',
    transform: `translateX(0px)`,
  }
}

const setStep = () => {
  const innerWidth = inner.value.scrollWidth
  const totalCards = reviews.value.length

  step.value = innerWidth / totalCards
}

const moveLeft = () => {
  innerStyles.value = {
    transition: 'transform 0.5s ease',
    transform: `translateX(-${step.value}px)`,
  }
}

const moveRight = () => {
  innerStyles.value = {
    transition: 'transform 0.5s ease',
    transform: `translateX(${step.value}px)`,
  }
}

const next = () => {
  if (transitioning.value) return
  transitioning.value = true
  moveLeft()
  afterTransition(() => {
    const firstElement = containerRef.value.querySelector('.reviews_carousel').firstElementChild
    containerRef.value.querySelector('.reviews_carousel').appendChild(firstElement)

    updateCurrent()
    resetTranslate()
    transitioning.value = false
  })
}

const prev = () => {
  if (transitioning.value) return
  transitioning.value = true
  moveRight()
  afterTransition(() => {
    const lastElement = containerRef.value.querySelector('.reviews_carousel').lastElementChild
    containerRef.value.querySelector('.reviews_carousel').prepend(lastElement)

    updateCurrent()
    resetTranslate()
    transitioning.value = false
  })
}

const updateCurrent = () => {
  const firstElementId = containerRef.value.querySelector('.reviews_carousel').firstElementChild.id
  current.value = Number(firstElementId.split('_')[1])
}

const handleSwipe = event => {
  if (!touchEvent.value) {
    return
  }
  touchEvent.value.setEndEvent(event)

  if (touchEvent.value.isSwipeRight()) {
    prev()
  } else if (touchEvent.value.isSwipeLeft()) {
    next()
  }
  touchEvent.value = null
}

const sendEvent = review => {
  appAnalytics.track(appAnalytics.events.RC_REVIEWS_READ_MORE_CLICKED, {
    review: review.text,
  })
}
</script>
<style scoped>
.middle {
  top: 50%;
  transform: translateY(-50%);
}
.reviews_carousel {
  padding-bottom: 1px;
  display: flex;
  margin: auto;
  white-space: nowrap;
  transition: transform 1s;
  @media (max-width: 768px) {
    width: 100%;
  }
}

.landing-card {
  background-color: var(--tw-color-white);
  border-radius: 12px;
  position: relative;
  margin-right: 50px;
  display: inline-flex;
  white-space: wrap;
  @media (max-width: 1023px) {
    min-width: 543px;
    width: 543px;
    min-height: 100%;
  }
  @media (max-width: 767px) {
    min-width: 299px;
    min-height: 100%;
  }
}

.card {
  background-color: var(--tw-color-white);
  border-radius: 12px;
  position: relative;
  margin-right: 50px;
  display: inline-flex;
  white-space: wrap;
  @media (max-width: 1023px) {
    min-width: 543px;
    width: 543px;
    min-height: 100%;
  }
  @media (max-width: 767px) {
    min-width: 479px;
    min-height: 100%;
  }

  @media (max-width: 500px) {
    min-width: 299px;
  }
}

.line-shadow {
  box-shadow: 1px 1px 0px 0px #000;
}
</style>
